<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddCommAdr"
      :is-valid="formValid"
      style="z-index:30009">
       <div>
        <div>

          <p>{{$t('ADD_COMM_ADR.HEADER.TEXT')}}</p>
          <vs-tabs v-model="activeTab">
            <vs-tab :label="$t('ADD_COMM_ADR.TAB.NAMES')">
              <vs-divider>{{$t('ADD_COMM_ADR.DIVIDER.COMPANY')}}</vs-divider>
              <div  class="default-input clearfix align-items-center mb-3">
                <vs-input ref="company" :label="$t('ADD_COMM_ADR.LABEL.FIRMA')" class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.FIRMA')"  v-model="company" />
                <vs-input :label="$t('ADD_COMM_ADR.LABEL.UID')"  class="float-left inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.UID')"  v-model="uid" />
              </div>
              <vs-divider>{{$t('ADD_COMM_ADR.DIVIDER.TITEL')}}</vs-divider>
              <div class="default-input clearfix align-items-center mb-3">
                <vs-input ref="titel_pre" :label="$t('ADD_COMM_ADR.LABEL.TITEL_PRE')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.TITEL_PRE')"  v-model="titel_pre"  />
                <vs-input :label="$t('ADD_COMM_ADR.LABEL.TITEL_POST')"  class="float-left inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.TITEL_POST')"  v-model="titel_post" />
              </div>
              <vs-divider>{{$t('ADD_COMM_ADR.DIVIDER.NAME')}}</vs-divider>
              <div class="clearfix align-items-center mb-3">
                <vs-input :label="$t('ADD_COMM_ADR.LABEL.FIRSTNAME')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.FIRSTNAME')"  v-model="firstname" :danger="firstname_fail" val-icon-danger="clear"/>
                <vs-input :label="$t('ADD_COMM_ADR.LABEL.SECONDNAME')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.SECONDNAME')" v-model="secondname" :danger="secondname_fail" val-icon-danger="clear" />
                <vs-input :label="$t('ADD_COMM_ADR.LABEL.LASTNAME')"  class="float-left inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.LASTNAME')" v-model="lastname" :danger="lastname_fail" val-icon-danger="clear"/>
              </div>            
            </vs-tab>
            <vs-tab :label="$t('ADD_COMM_ADR.ADDRESS')">
                  <div class="default-input clearfix align-items-center mt-3 mb-3">
                    <vs-input ref="street1" :label="$t('ADD_COMM_ADR.LABEL.STREET1')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.STREET1')"  v-model="street1" :danger="street1_fail" val-icon-danger="clear"/>
                    <vs-input :label="$t('ADD_COMM_ADR.LABEL.STREET2')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.STREET2')"  v-model="street2" />
                  </div>
                  <div class="default-input clearfix align-items-center mb-3">
                    <vs-input :label="$t('ADD_COMM_ADR.LABEL.PLZ')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.PLZ')"  v-model="plz" :danger="plz_fail" val-icon-danger="clear"  :danger-text="$t('ADD_COMM_ADR.PLZ_FAIL')"/>
                    <vs-input :label="$t('ADD_COMM_ADR.LABEL.CITY')"  class="float-left mr-3 inputx" :placeholder="$t('ADD_COMM_ADR.LABEL.PLACEHOLDER.CITY')"  v-model="city" :danger="city_fail" val-icon-danger="clear"/>
                  </div>
                  <div class="default-input clearfix align-items-center mb-3">
                    <vs-select :label="$t('ADD_COMM_ADR.LABEL.COUNTRY')" v-model="country_fk" class="float-left" :danger="country_fk_fail">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in countries" />
                    </vs-select>
                  </div>
            </vs-tab>
          </vs-tabs>
        </div>
        <div class="d-flex">
          <vs-button v-if="activeTab > 0 " class="mr-3" type="filled" icon="arrow_back_ios" @click="back()">{{$t('COM.BACK')}}</vs-button>
          <vs-button v-if="activeTab < idLastTab" type="filled" icon="arrow_forward_ios" @click="next()">{{$t('COM.NEXT')}}</vs-button>
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';

export default {
  name: "AddCommAdrDlg",
  props:['InitData'],
  data: function (){
     return {
       id:0,

       dlgActive: false,
       activeTab: 0,
       idLastTab: 1,

       titel_pre:"",
       titel_post:"",
       firstname:"",
       firstname_fail:false,
       firstname_ok:false,
       secondname:"",
       secondname_fail:false,
       lastname:"",
       lastname_fail:false,
       lastname_ok:false,

       uid:"",
       company:"",

       street1:"",
       street1_fail:false,
       street1_ok:false,
       street2:"",
       plz:"",
       plz_fail:false,
       plz_ok:false,
       city:"",
       city_fail:false,
       city_ok:false,
       country_fk:-1,
       country_fk_fail:false,
       country_fk_ok:false,
       popupTitle: this.$t('ADD_COMM_ADR.TITLE')
     }
  }, 
  mounted () {
    this.ClearForm();
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      next(){
        this.activeTab += 1;
      },
      back(){
        this.activeTab -= 1;
      },
      showDlg(){
        this.ClearForm();

        this.dlgActive=true;
      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        
        if(this.IsNotNull(data))
        {
          this.id = data.id;
          this.firstname = data.firstname;
          this.secondname = data.secondname;
          this.lastname = data.lastname;
          this.titel_pre = data.titel_pre;
          this.titel_post = data.titel_post;
          this.uid = data.uid;
          this.company = data.company;

          this.street1 = data.street1;
          this.street2 = data.street2;
          this.plz = data.plz;
          this.city = data.city;
          this.country_fk = data.country_fk;
        
          this.country_fk_fail = data.country_fk <= 0;
          this.country_fk_ok = !this.country_fk_fail;

          this.popupTitle = this.$t('ADD_COMM_ADR.TITLE.EDIT') + ' (' + this.firstname + ' ' + this.lastname + ')';

          this.dlgActive=true;
        }
      },
      accepted(){

          var data = {
            "id":this.id,
            "firstname":this.firstname,
            "secondname":this.secondname,
            "lastname":this.lastname,
            "titel_pre":this.titel_pre,
            "titel_post":this.titel_post,
            "uid":this.uid,
            "company":this.company,

            "street1":this.street1,
            "street2":this.street2,
            "plz":this.plz,
            "city":this.city,
            "country_fk":this.country_fk
          };

          // Emit to parent component for handling save
          this.$emit('Accepted', data);
          
          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
      },
      isNameFail(name,isMustHave){
        var fail = false;
        if(isMustHave)
        {
          if(name.length > 0)
          {
              if(!this.ContainNoNumbers(name))
              {
                // Name enthält Zahlen
                fail = true;
              }
          }
          else
          {
            fail = true;
          }
        }
        else
        {
         fail = !this.ContainNoNumbers(name);
        }
        return fail;
      },
      ClearForm(){
        this.id = 0;

        this.activeTab =  0;

        this.titel_pre = "";
        this.titel_post = "";
        this.firstname = "";
        this.firstname_fail = false;
        this.firstname_ok = false;
        this.secondname = "";
        this.secondname_fail = false;
        this.lastname = "";
        this.lastname_fail = false;
        this.lastname_ok = false;

        this.uid = "";
        this.company = "";

        this.street1 = "";
        this.street1_fail = false;
        this.street1_ok = false;
        this.street2 = "";
        this.plz = "";
        this.plz_fail = false;
        this.plz_ok = false;
        this.city = "";
        this.city_fail = false;
        this.city_ok = false;
        this.country_fk = -1;
        this.country_fk_fail = false;
        this.country_fk_ok = false;

        if(this.countries.length > 1 )
        {
          this.country_fk = this.countries[1].value;
          this.country_fk_fail = this.country_fk  <= 0;
          this.country_fk_ok = !this.country_fk_fail;
        }

        this.popupTitle = this.$t('ADD_COMM_ADR.TITLE');
      }
  },
  computed:{
    countries(){
      return this.GetListOfCountriesForSelect(false);
    },
    formValid(){
        let valid = this.street1_ok && this.plz_ok && this.city_ok && this.country_fk_ok && ((this.firstname_ok && this.lastname_ok)||(this.company.length > 0));

        return valid;
    }
  },
  watch:{
    activeTab(value){
      switch(value)
      {
        case 0:
          this.$nextTick(() => this.setFocusOnInput('company'));
          break;
        case 1:
          this.$nextTick(() => this.setFocusOnInput('street1'));
          break;        
      }
    },

    firstname(value)
    {
      this.firstname_fail = this.isNameFail(value,true);
      this.firstname_ok = !this.firstname_fail;
    },
    secondname(value)
    {
      this.secondname_fail = this.isNameFail(value,false);
    },
    lastname(value)
    {
      this.lastname_fail = this.isNameFail(value,true);
      this.lastname_ok = !this.lastname_fail && value.length > 0;
    },


    street1(value){
      this.street1_fail = value.length == 0;
      this.street1_ok = !this.street1_fail;
    },
    plz(value){
      this.plz_fail = value.length == 0 || !this.ContainNumbersOnly(value);
      this.plz_ok = !this.plz_fail;
    },
    city(value){
      this.city_fail = value.length == 0;
      this.city_ok = !this.city_fail;
    },
    country_fk(value){
      this.country_fk_fail = value <= 0;
      this.country_fk_ok = !this.country_fk_fail;
    }
  }
};
</script>
<style>
div#promptAddCommAdr > div.vs-dialog{
  max-width: 800px !important;
}
div#promptAddCommAdr > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}
</style>
